export const ISV_WMP_CONSENT = "ISV WMP Consent";
